'use client';
import { isString, isNumber } from '@s7/utils';
import { isConvertibleColor } from '../../../modules/colors/impl/validators/validators.js';
import { toRGBA } from '../../../modules/colors/impl/toRGBA/toRGBA.js';

const rgba = (color, alpha = 1)=>{
    if (!isString(color) || isNumber(alpha) && (alpha > 1 || alpha < 0)) {
        return 'rgba(0, 0, 0, 1)';
    }
    if (!isConvertibleColor(color)) {
        return color;
    }
    const { r, g, b } = toRGBA(color);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export { rgba };
//# sourceMappingURL=rgba.js.map
